import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('system', [
      'systemConfiguration',
      'appName',
      'primaryColor',
      'secondaryColor',
      'logoUrl',
      'logoTextUrl',
      'faviconUrl',
      'pwaConfig'
    ])
  },
  
  methods: {
    // Helper method to get system colors for Vuetify themes
    getSystemTheme() {
      return {
        primary: this.primaryColor,
        secondary: this.secondaryColor
      };
    },
    
    // Helper method to update CSS custom properties
    updateCSSVariables() {
      document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      document.documentElement.style.setProperty('--secondary-color', this.secondaryColor);
      document.documentElement.style.setProperty('--system-app-name', `'${this.appName}'`);
    },
    
    // Update Vuetify theme colors (Vuetify 1.x compatible)
    updateVuetifyTheme() {
      if (this.$vuetify && this.$vuetify.theme) {
        // Vuetify 1.x usa estrutura diferente
        this.$vuetify.theme.primary = this.primaryColor;
        this.$vuetify.theme.secondary = this.secondaryColor;
      }
    },
    
    // Apply all system configurations
    applySystemConfiguration() {
      this.updateCSSVariables();
      this.updateVuetifyTheme();
      
      // Update document title
      if (this.appName) {
        document.title = this.appName;
      }
    }
  },
  
  watch: {
    primaryColor: {
      handler(newColor) {
        if (newColor) {
          document.documentElement.style.setProperty('--primary-color', newColor);
          
          if (this.$vuetify && this.$vuetify.theme) {
            this.$vuetify.theme.primary = newColor;
          }
        }
      },
      immediate: true
    },
    
    secondaryColor: {
      handler(newColor) {
        if (newColor) {
          document.documentElement.style.setProperty('--secondary-color', newColor);
          if (this.$vuetify && this.$vuetify.theme) {
            this.$vuetify.theme.secondary = newColor;
          }
        }
      },
      immediate: true
    },
    
    appName: {
      handler(newName) {
        if (newName) {
          document.documentElement.style.setProperty('--system-app-name', `'${newName}'`);
        }
      },
      immediate: true
    }
  },
  
  mounted() {
    // Apply configuration when component mounts
    this.$nextTick(() => {
      this.applySystemConfiguration();
    });
  }
};